import _ from 'lodash';

const OMIT_FIELDS = ['_id', 'instanceId', 'totalPosts', 'totalViews', 'isSubscribed', 'slug'];

export const UPDATE_CATEGORY_REQUEST = 'category/UPDATE_REQUEST';
export const UPDATE_CATEGORY_SUCCESS = 'category/UPDATE_SUCCESS';
export const UPDATE_CATEGORY_FAILURE = 'category/UPDATE_FAILURE';

export const updateCategoryRequest = () => ({ type: UPDATE_CATEGORY_REQUEST });
export const updateCategorySuccess = payload => ({ type: UPDATE_CATEGORY_SUCCESS, payload });
export const updateCategoryFailure = () => ({ type: UPDATE_CATEGORY_FAILURE });

export function updateCategory(categoryId, data) {
  return (dispatch, getState, { request }) => {
    dispatch(updateCategoryRequest());

    const promise = request.patch(`/_api/categories/${categoryId}`, _.omit(data, OMIT_FIELDS));
    return promise
      .then(updatedCategory => dispatch(updateCategorySuccess(updatedCategory)))
      .catch(() => dispatch(updateCategoryFailure()))
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/update-category.js